import { createSelector } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';
import { map } from 'lodash';

const getPortalState = createFeatureSelector('PORTAL_STORE');

// Selects View Slice
export const getMyStudentsViewState = createSelector(
  getPortalState,
  (state: any) => state.myStudents,
);
export const getAttendanceViewState = createSelector(
  getPortalState,
  (state: any) => state.attendanceStudents,
);
export const getAcademicViewState = createSelector(
  getPortalState,
  (state: any) => state.academicStudents,
);
export const getPostsecViewState = createSelector(
  getPortalState,
  (state: any) => state.postsecondaryStudents,
);

// View Slice Loading Status
export const getMyStudentsLoadingStatus = createSelector(
  getMyStudentsViewState,
  (state: any) => state.loading,
);
export const getAttendanceStudentsLoadingStatus = createSelector(
  getAttendanceViewState,
  (state: any) => state.loading,
);
export const getAcademicStudentsLoadingStatus = createSelector(
  getAcademicViewState,
  (state: any) => state.loading,
);
export const getPostsecondaryLoadingStatus = createSelector(
  getPostsecViewState,
  (state: any) => state.loading,
);

// View Slice Loaded Status
export const getMyStudentsLoadedStatus = createSelector(
  getMyStudentsViewState,
  (state: any) => state.loaded,
);
export const getAttendanceStudentsLoadedStatus = createSelector(
  getAttendanceViewState,
  (state: any) => state.loaded,
);
export const getAcademicStudentsLoadedStatus = createSelector(
  getAcademicViewState,
  (state: any) => state.loaded,
);
export const getPostsecondaryStudentsLoadedStatus = createSelector(
  getPostsecViewState,
  (state: any) => state.loaded,
);

// View Slice Students
export const getMyStudentsListEntities = createSelector(
  getMyStudentsViewState,
  (state: any) => state.studentEntities,
);
export const getAttendanceListEntities = createSelector(
  getAttendanceViewState,
  (state: any) => state.studentEntities,
);
export const getAcademicListEntities = createSelector(
  getAcademicViewState,
  (state: any) => state.studentEntities,
);
export const getPostsecListEntities = createSelector(
  getPostsecViewState,
  (state: any) => state.studentEntities,
);

// View Slice Sort
export const getMyStudentsListSort = createSelector(
  getMyStudentsViewState,
  (state: any) => state.sort,
);
export const getAttendanceListSort = createSelector(
  getAttendanceViewState,
  (state: any) => state.sort,
);
export const getAcademicListSort = createSelector(
  getAcademicViewState,
  (state: any) => state.sort,
);
export const getPostsecondaryListSort = createSelector(
  getPostsecViewState,
  (state: any) => state.sort,
);

// View Slice Dimensions
export const getMyStudentsListDimensions = createSelector(
  getMyStudentsViewState,
  (state: any) => state.dimensions,
);
export const getAttendanceListDimensions = createSelector(
  getAttendanceViewState,
  (state: any) => state.dimensions,
);
export const getAcademicListDimensions = createSelector(
  getAcademicViewState,
  (state: any) => state.dimensions,
);
export const getPostsecListDimensions = createSelector(
  getPostsecViewState,
  (state: any) => state.dimensions,
);

// Get students entities as an Array<students>
export const getMyStudentsList = createSelector(
  getMyStudentsViewState,
  (state: any) => {
    const studentEntities = state.studentEntities;
    return map(studentEntities, (v, k) => v);
  },
);

export const getAttendanceStudentsList = createSelector(
  getAttendanceViewState,
  (state: any) => {
    const studentEntities = state.studentEntities;
    return map(studentEntities, (v, k) => v);
  },
);

export const getAcademicStudentsList = createSelector(
  getAcademicViewState,
  (state: any) => {
    const studentEntities = state.studentEntities;
    return map(studentEntities, (v, k) => v);
  },
);

export const getPostsecondaryStudentsList = createSelector(
  getPostsecViewState,
  (state: any) => {
    const studentEntities = state.studentEntities;
    return map(studentEntities, (v, k) => v);
  },
);

// Loaded Projection For View Slice
export const getMyStudentsProjection = createSelector(
  getMyStudentsViewState,
  (state: any) => state.loadedProjection,
);

export const getAttendanceStudentsProjection = createSelector(
  getAttendanceViewState,
  (state: any) => state.loadedProjection,
);

export const getAcademicStudentsProjection = createSelector(
  getAcademicViewState,
  (state: any) => state.loadedProjection,
);

export const getPostsecondaryStudentsProjection = createSelector(
  getPostsecViewState,
  (state: any) => state.loadedProjection,
);
